<template>
  <div class="coupon-stock-card mb-3">
    <template v-if="item">
      <img :src="item.image | imagePath('couponCover', 'thumbnail')"
           :alt="item.name1"
      >
      <h3 class="title">{{ item.name1 }}</h3>
      <div class="stock-available" v-if="isShowStockQuantity">
        <span class="stock-available__label">已使用</span>
        <br>
        <span class="stock-available__value">
          <template>
            {{ item.isUsed }}
          </template>
        </span>
      </div>
      <div class="stock-available border-left" v-if="isShowStockQuantity">
        <span class="stock-available__label">庫存</span>
        <br>
        <span class="stock-available__value">
          <template v-if="item.quantity > 0">
            {{ item.available || 0 }}/{{ item.quantity }}
          </template>
          <template v-else>不限</template>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import imagePath from '@/filters/image-path';
import http from '../../helpers/http';

export default {
  props: { id: Number, isShowStockQuantity: Boolean },
  computed: {
    ...mapGetters(['role']),
  },
  filters: {
    imagePath,
  },
  subscriptions() {
    return {
      item: http({
        method: 'GET',
        url: `/agc-${this.role}-api/coupons/stockCard/${this.id}`,
      }),
    };
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixin/modal/modal-history-status';

.coupon-stock-card {
  @include container;

  img {
    @include image;
  }

  .title {
    @include title;
  }
}

.border-left {
  border-left: 1px solid #dde1e5;
}

.stock-available {
  text-align: center;
  padding: 0 18px 0 24px;
  font-weight: 500;

  @include respond(phone) {
    padding: 0 10px;
  }

  &__label {
    color: #636d77;
    font-size: 13px;
    font-weight: 400;
    min-width: 2.5rem;
    display: inline-block;

  }

  &__value {
    color: #3A4047;
    font-size: 1.2rem;
    font-weight: 500;

    @include respond(phone) {
      font-size: 1rem;
    }
  }
}
</style>
